import React, { FC } from 'react';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { useLocalizationContext } from '@im/react-localization';

import { LOCALE_SUPPORTED } from 'src/config';

LOCALE_SUPPORTED.forEach((locale) => require(`dayjs/locale/${locale.substring(0, 2)}`)); //eslint-disable-line

const DatePickerProvider: FC = ({ children }) => {
  const localization = useLocalizationContext();
  return (
    <LocalizationProvider
      adapterLocale={localization.locale.split('-')[0]}
      dateAdapter={AdapterDayjs}
    >
      {children}
    </LocalizationProvider>
  );
};

export { DatePickerProvider };
